import { axiosInstance } from "@src/shared/api";
import { USER_API_URL } from "../constants";
import { useAuthStore } from "@src/entities/login/model/store/authStore";

export interface ChangePasswordRequestDto {
  current_password: string;
  new_password: string;
}

export const changePassword = (data: ChangePasswordRequestDto) => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  return axiosInstance.post(USER_API_URL.changePassword(), data, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};
